module.exports = __webpack_public_path__ + "flyer_background_crystal_120-84f0b74a4157c6b3929e7d54bdf477cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_crystal_120.jpg
// module id = 1632
// module chunks = 1